import styled, { css } from 'styled-components';
import { LAYOUT, media } from '@app/styles/themes/constants';
import { BaseLayout } from '@app/components/common/BaseLayout/BaseLayout';

interface HeaderProps {
  $isTwoColumnsLayout: boolean;
  $isNoOffsetMainContent: boolean;
  $isFishingInspectionPage: boolean;
}

export default styled(BaseLayout.Content)<HeaderProps>`
  padding: ${LAYOUT.mobile.paddingVertical} ${LAYOUT.mobile.paddingHorizontal};
  overflow: auto;
  ${(props) =>
    !props.$isFishingInspectionPage &&
    css`
      display: flex;
      flex-direction: column;
    `}

  @media only screen and ${media.md} {
    padding: ${(props) =>
      !props.$isNoOffsetMainContent ? `${LAYOUT.desktop.paddingVertical} ${LAYOUT.desktop.paddingHorizontal}` : 0};
  }

  @media only screen and ${media.xl} {
    ${(props) =>
      props?.$isTwoColumnsLayout &&
      css`
        padding: 0;
      `}
  }
`;
